<template>
  <div class="column">
    <h2 class="subtitle">
      {{ title }}
    </h2>
    <p>
      <b>Razão Social: </b>
      {{ companyInfo.companyName }}
    </p>
    <p v-show="companyInfo.doingBusinessAs">
      <b>Nome Fantasia: </b>
      {{ companyInfo.doingBusinessAs }}
    </p>
    <p>
      <b>CNPJ: </b>
      {{ formatBusinessId(companyInfo.nationalCompanyId) }}
    </p>
  </div>
</template>

<script>
import { mask } from "../../../mixins/mask";

export default {
  mixins: [mask],
  props: ["companyInfo", "title"]
};
</script>
